"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GTM_PRODUCT_OFFERING_ATTACHMENT_EMPTY = exports.GTM_PRODUCT_PROMOTION_TEXT_EMPTY = exports.GTM_PRODUCT_OFFERING_TEXT_EMPTY = void 0;
var GTM_PRODUCT_OFFERING_TEXT_EMPTY = {
  event: 'asyncGTM',
  GAcategory: 'Seguimiento de errores',
  GAaction: 'error al recuperar el texto con textTypeId %?% sobre el product Offering  %?%',
  GAlabel: '' // ProcessName

};
exports.GTM_PRODUCT_OFFERING_TEXT_EMPTY = GTM_PRODUCT_OFFERING_TEXT_EMPTY;
var GTM_PRODUCT_PROMOTION_TEXT_EMPTY = {
  event: 'asyncGTM',
  GAcategory: 'Seguimiento de errores',
  GAaction: 'error al recuperar el texto con textTypeId %?% sobre el product promotion  %?%',
  GAlabel: '' // ProcessName

};
exports.GTM_PRODUCT_PROMOTION_TEXT_EMPTY = GTM_PRODUCT_PROMOTION_TEXT_EMPTY;
var GTM_PRODUCT_OFFERING_ATTACHMENT_EMPTY = {
  event: 'asyncGTM',
  GAcategory: 'Seguimiento de errores',
  GAaction: 'error al recuperar el attachment con attachmentType %?% sobre el product offering  %?%',
  GAlabel: '' // ProcessName

};
exports.GTM_PRODUCT_OFFERING_ATTACHMENT_EMPTY = GTM_PRODUCT_OFFERING_ATTACHMENT_EMPTY;

//# sourceMappingURL=constants.js.map